import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result } from '@digibricks/domains';
import { EXAMINATION_SUBMISSION_API } from '../data-sources';
import { EXAMINATION_SUBMISSION_REPOSITORY } from '../../core';
export var ExaminationSubmissionRepository = /*#__PURE__*/function () {
  function ExaminationSubmissionRepository(examinationSubmissionApi) {
    _classCallCheck(this, ExaminationSubmissionRepository);

    this.examinationSubmissionApi = examinationSubmissionApi;
  }

  _createClass(ExaminationSubmissionRepository, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var responseOrError, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.examinationSubmissionApi.create(input);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                response = responseOrError.getValue();
                return _context.abrupt("return", Result.ok(response));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.examinationSubmissionApi.submit(useCaseInput);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                return _context2.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function submit(_x2) {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.examinationSubmissionApi.update(input);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                return _context3.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x3) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return ExaminationSubmissionRepository;
}();
export var examinationSubmissionRepositoryProvider = {
  provide: EXAMINATION_SUBMISSION_REPOSITORY,
  useFactory: function useFactory(examinationSubmissionApi) {
    return new ExaminationSubmissionRepository(examinationSubmissionApi);
  },
  inject: [EXAMINATION_SUBMISSION_API]
};